module.exports = {"TXTCLI_Join_a_club":{"id":"TXTCLI_Join_a_club","defaultMessage":"Lid worden van een club","track":"Join a club"}}